/* eslint-disable react/prop-types */
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { observer, inject } from "mobx-react";
import MyDetails from './MyDetails';
import MyOrders from './MyOrders';
import MyDownloads from './MyDownloads';
import { hexToRgba } from '@/utils/misc';

const AccountTabs = inject('studioStore')(observer(({ studioStore, userData, fetchUserData, countries, activeTab: initialTab }) => {
  const [activeTab, setActiveTab] = useState(initialTab || 'my-details');
  const t = useTranslations('Account');
  const primaryColor = studioStore.settings.colors.primary_color;
  const container = studioStore.settings.login_register?.container;
  const containerBackgroundColor = studioStore.settings.login_register?.container_background_color;

  let classes = "";
  const style = {
    backgroundColor: containerBackgroundColor,
  };

  if (container === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${containerBackgroundColor}),linear-gradient(${containerBackgroundColor} 0px, ${containerBackgroundColor} 0px)`;
    style.backgroundColor = '';
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'my-details':
        return <MyDetails userData={userData} refreshUserData={fetchUserData} countries={countries} />;
      case 'my-orders':
        return <MyOrders userData={userData} />;
      case 'my-downloads':
        return <MyDownloads />;
      default:
        return <MyDetails userData={userData} refreshUserData={fetchUserData} countries={countries} />;
    }
  };

  return (
    <div className="flex flex-wrap">
      <div className={`${classes} w-full md:w-1/4 px-6 py-12`} style={style}>
        <ul className="space-y-4 p-3">
          <li>
            <button
              onClick={() => setActiveTab('my-details')}
              style={activeTab === 'my-details'
                ? { backgroundColor: primaryColor, color: 'white' }
                : { backgroundColor: hexToRgba(primaryColor, 0.1) }}
              className="block w-full p-2 transition duration-300"
              data-testid="my-details-tab"
            >
              {t('my_details')}
            </button>
          </li>
          <li>
            <button
              onClick={() => setActiveTab('my-orders')}
              style={activeTab === 'my-orders'
                ? { backgroundColor: primaryColor, color: 'white' }
                : { backgroundColor: hexToRgba(primaryColor, 0.1) }}
              className="block w-full p-2 transition duration-300"
            >
              {t('my_orders')}
            </button>
          </li>
          { // TODO: Digital downloads tab
          /* <li>
            <button
              onClick={() => setActiveTab('downloads')}
              className={`block w-full p-2 ${activeTab === 'downloads' ? 'bg-white font-bold' : 'bg-gray-100'}`}
            >
              {t('my_downloads')}
            </button>
          </li> */}
        </ul>
      </div>
      <div className={`${classes} w-full md:w-3/4 px-6 py-12`} style={style}>
        {renderContent()}
      </div>
    </div>
  );
}));

export default AccountTabs;
